import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Catalog Images route (`/explorer/catalog-images`). Super-admin only —
 * the parent Explorer layout is unguarded, so the guard lives here
 * (mirrors the sibling `datalake` route). Lazy-loaded to stay off the initial
 * authenticated bundle.
 */
const CatalogImagesPage = lazy(() => import('~/features/explorer/pages/catalog-images-page'));

// Persist the page-local subsidiary scope in the URL so a reload / shared link
// keeps the picked subsidiary instead of snapping back to the active tenant.
// The param is deliberately opaque (`sc`) so it doesn't leak "subsidiary" in
// the address bar.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/catalog-images')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <CatalogImagesPage />
    </Suspense>
  );
}
